const CreateTransactionError = require('./CreateTransactionError');
const CoinSelectionUnsufficientUTXOS = require('./CoinSelectionUnsufficientUTXOS');
const InjectionErrorCannotInject = require('./InjectionErrorCannotInject');
const InjectionErrorCannotInjectUnknownDependency = require('./InjectionErrorCannotInjectUnknownDependency');
const InjectionToPluginUnallowed = require('./InjectionToPluginUnallowed');

const PluginFailedOnStart = require('./PluginFailedOnStart');
const WorkerFailedOnStart = require('./WorkerFailedOnStart');
const WorkerFailedOnExecute = require('./WorkerFailedOnExecute');

const InvalidAddress = require('./InvalidAddress');
const InvalidAddressObject = require('./InvalidAddressObject');
const InvalidOutput = require('./InvalidOutput');
const InvalidDashcoreTransaction = require('./InvalidDashcoreTransaction');
const InvalidRawTransaction = require('./InvalidRawTransaction');
const InvalidStrategy = require('./InvalidStrategy');
const InvalidStorageAdapter = require('./InvalidStorageAdapter');

const InvalidTransactionObject = require('./InvalidTransactionObject');
const InvalidUTXO = require('./InvalidUTXO');
const StorageUnableToAddTransaction = require('./StorageUnableToAddTransaction');
const TransactionNotInStore = require('./TransactionNotInStore');
const TransactionMetadataNotInStore = require('./TransactionMetadataNotInStore');
const BlockHeaderNotInStore = require('./BlockHeaderNotInStore');

const UnknownWorker = require('./UnknownWorker');
const UnknownPlugin = require('./UnknownPlugin');

const ValidTransportLayerRequired = require('./ValidTransportLayerRequired');
const WalletLibError = require('./WalletLibError');

const PluginInjectionError = require('./PluginInjectionError');
const InstantLockTimeoutError = require('./InstantLockTimeoutError');
const TxMetadataTimeoutError = require('./TxMetadataTimeoutError');

module.exports = {
  BlockHeaderNotInStore,
  CreateTransactionError,
  CoinSelectionUnsufficientUTXOS,
  InjectionErrorCannotInject,
  InjectionErrorCannotInjectUnknownDependency,
  InjectionToPluginUnallowed,
  InvalidAddress,
  InvalidAddressObject,
  InvalidOutput,
  InvalidStrategy,
  InvalidDashcoreTransaction,
  InvalidRawTransaction,
  InvalidStorageAdapter,
  InvalidTransactionObject,
  InvalidUTXO,
  PluginFailedOnStart,
  WorkerFailedOnStart,
  WorkerFailedOnExecute,
  StorageUnableToAddTransaction,
  TransactionNotInStore,
  TransactionMetadataNotInStore,
  UnknownPlugin,
  UnknownWorker,
  ValidTransportLayerRequired,
  WalletLibError,
  PluginInjectionError,
  InstantLockTimeoutError,
  TxMetadataTimeoutError,
};
